import { useEffect, useState } from "react";
import { getSignedUrl } from "../lib/supabase";

// Proof-of-service photo for a completed job. The job-photos bucket is PRIVATE,
// so we mint a short-lived signed URL (RLS in sql/028 lets only the owning org
// sign it). `path` is the storage object key from jobs.photo_url ("<job_id>/<file>").
export function JobPhoto({ path, size = 44 }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setUrl(null); setErr(false);
    getSignedUrl("job-photos", path).then(u => {
      if (cancelled) return;
      if (u) setUrl(u); else setErr(true);
    });
    return () => { cancelled = true; };
  }, [path]);

  // Say it in text — a title= tooltip never shows on touch, leaving a bare 📷 glyph.
  if (err)  return <span style={{ fontSize: 12, color: "#b3bac5", whiteSpace: "nowrap" }} title="Photo unavailable">📷 <span style={{ fontSize: 11 }}>unavailable</span></span>;
  if (!url) return <span style={{ fontSize: 12, color: "#8993a4" }}>…</span>;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" title="Open full photo">
      <img src={url} alt="Service proof" loading="lazy"
        style={{ width: size, height: size, objectFit: "cover", borderRadius: 6, border: "1px solid #e3e8ef", display: "block", cursor: "zoom-in" }} />
    </a>
  );
}
